/**
 * Constants for Settings page component
 */

export const PRIMARY_BUTTON_STYLES = {
  background: 'linear-gradient(135deg, #233491, #2f4ac4)',
  color: '#FFFFFF',
  textTransform: 'none',
  boxShadow: '0 4px 12px rgba(35, 52, 145, 0.35)',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    background: 'linear-gradient(135deg, #2f4ac4, #233491)',
    boxShadow: '0 6px 16px rgba(35, 52, 145, 0.45)',
    transform: 'translateY(-1px)',
  },
  '&:active': {
    transform: 'translateY(0)',
    boxShadow: '0 2px 8px rgba(35, 52, 145, 0.3)',
  },
  '&:disabled': {
    backgroundColor: '#e5e7eb',
    color: '#9ca3af',
    boxShadow: 'none',
    transform: 'none',
  },
};

export const DEFAULT_PROFILE_DATA = {
  name: '',
  email: '',
  phone: '',
  whatsappNumber: '',
  designation: '',
  department: '',
};

export const DEFAULT_NOTIFICATION_SETTINGS = {
  emailNotifications: true,
  whatsappNotifications: true,
  inAppNotifications: true,
};

export const DEFAULT_PASSWORD_DATA = {
  currentPassword: '',
  newPassword: '',
  confirmPassword: '',
};

export const DEFAULT_SHOW_PASSWORDS = {
  current: false,
  new: false,
  confirm: false,
};

export const MIN_PASSWORD_LENGTH = 6;
